/* eslint-disable react/no-danger */
import React from 'react'
import Image from 'next/image'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import assetLoader from '@utils/internalImageLoader'
import { convertToSlug } from 'src/utils/IdGenerator'
import { getClassNames } from '@helpers/productWidgetHelper'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import TestimonialItems from './testimonialItems'
import { STATIC_VARIANT } from './constants'
import styles from './testimonial.module.scss'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

const testimonial = ({ data }) => {
  const testimonialData = data?.data?.attributes
  const { isSemPage, widgetType } = data

  const getModifiedHtml = tableContent => {
    const $ = cheerio.load(tableContent, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  // for id assign
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = data?.data?.attributes?.sectionHeading.match(h2Regex)
  const h2Content = matches ? matches[1] : null
  const isSeoVasTestimonial = isVasWidget(widgetType) && !isSemPage

  // base/conditional classes
  const testimonialRootClassNames = getClassNames([styles.testimonialRootContainer], {
    [styles.noGradient]: testimonialData?.variant === STATIC_VARIANT,
    [styles.seoStyles]: isSeoVasTestimonial,
  })

  const sectionHeadingClassNames = getClassNames([styles.sectionHeading], {
    [styles.leftAlign]: testimonialData?.variant === STATIC_VARIANT && !isSeoVasTestimonial,
  })

  return (
    <ErrorBoundary data={data}>
      <div className={testimonialRootClassNames} id={convertToSlug(h2Content)}>
        <div
          className={sectionHeadingClassNames}
          dangerouslySetInnerHTML={{ __html: getModifiedHtml(testimonialData?.sectionHeading) }}
        />

        {testimonialData?.variant !== STATIC_VARIANT && (
          <div className={styles.imageContainer}>
            <Image
              src={`${assetLoader()}/images/testimonial-rating.svg`}
              alt="Testimonial Pattern"
              height="100"
              width="300"
              loading="lazy"
            />
          </div>
        )}
        <TestimonialItems testimonialValues={testimonialData} />
      </div>
    </ErrorBoundary>
  )
}

export default testimonial
